window.MaissonDesign = (() => {
  const jobs = [];
  let controller;
  let cleanups = [];
  const run = () => {
    controller?.abort();
    cleanups.forEach(dispose => dispose());
    cleanups = [];
    controller = new AbortController();
    const on = (target, name, callback, options = {}) => target?.addEventListener(name, callback, {...options, signal:controller.signal});
    jobs.forEach(job => job({on, cleanup:fn => cleanups.push(fn)}));
  };
  document.addEventListener('shopify:section:load',run);
  document.addEventListener('shopify:section:unload',() => { controller?.abort(); cleanups.forEach(fn=>fn()); cleanups=[]; requestAnimationFrame(run); });
  return {register(job){jobs.push(job);run();}};
})();
